import { defineComponent as _defineComponent } from 'vue';
import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, toDisplayString as _toDisplayString, resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx } from "vue";
const _hoisted_1 = { class: "system-status-page" };
const _hoisted_2 = { class: "content" };
const _hoisted_3 = {
    key: 0,
    class: "loading"
};
const _hoisted_4 = {
    key: 1,
    class: "toggles"
};
const _hoisted_5 = { class: "toggle-label" };
const _hoisted_6 = {
    key: 2,
    class: "saving"
};
import { ref, onMounted } from 'vue';
import { useAdmin } from '@/composables/useAdmin';
import MGButton from '@/components/elements/MGButton.vue';
import MGDialog from '@/components/elements/MGDialog.vue';
import SuccessToast from '@/components/elements/SuccessToast.vue';
export default /*@__PURE__*/ _defineComponent({
    __name: 'SystemStatusPage',
    setup(__props) {
        const admin = useAdmin();
        // ponytail: field list drives both fetch defaults and the UI; preserves the linkBankAvaialable typo the API uses
        const fields = [
            { key: 'systemAvailable', label: 'System Available' },
            { key: 'voucherStoreAvailable', label: 'Voucher Store' },
            { key: 'aiChatAvailable', label: 'AI Chat' },
            { key: 'documentUploadAvailable', label: 'Document Upload' },
            { key: 'payByBankAvailable', label: 'Pay By Bank' },
            { key: 'stripeAvailable', label: 'Stripe' },
            { key: 'addressLookupAvailable', label: 'Address Lookup' },
            { key: 'linkBankAvaialable', label: 'Link Bank' }
        ];
        const status = ref({});
        const loading = ref(true);
        const saving = ref(false);
        const savedCount = ref(0);
        const showConfirm = ref(false);
        function load() {
            loading.value = true;
            admin.getSystemStatus((result) => {
                status.value = result || {};
                loading.value = false;
            });
        }
        function confirmSave() {
            showConfirm.value = false;
            saving.value = true;
            admin.saveSystemStatus(status.value, () => {
                saving.value = false;
                savedCount.value = 1;
            }, (error) => {
                saving.value = false;
                console.error('Error saving system status:', error);
            });
        }
        onMounted(load);
        return (_ctx, _cache) => {
            const _component_v_switch = _resolveComponent("v-switch");
            return (_openBlock(), _createElementBlock("div", _hoisted_1, [
                _createElementVNode("div", _hoisted_2, [
                    _cache[4] || (_cache[4] = _createElementVNode("h2", null, "System Status", -1)),
                    _cache[5] || (_cache[5] = _createElementVNode("p", { class: "hint" }, "Toggle availability of each subsystem. Turning a switch off makes that feature unavailable in the app.", -1)),
                    (loading.value)
                        ? (_openBlock(), _createElementBlock("div", _hoisted_3, "Loading…"))
                        : (_openBlock(), _createElementBlock("div", _hoisted_4, [
                            (_openBlock(), _createElementBlock(_Fragment, null, _renderList(fields, (field) => {
                                return _createElementVNode("label", {
                                    key: field.key,
                                    class: "toggle-row"
                                }, [
                                    _createElementVNode("span", _hoisted_5, _toDisplayString(field.label), 1),
                                    _createVNode(_component_v_switch, {
                                        modelValue: status.value[field.key],
                                        "onUpdate:modelValue": ($event) => ((status.value[field.key]) = $event),
                                        color: "primary",
                                        "hide-details": "",
                                        density: "compact",
                                        inset: ""
                                    }, null, 8, ["modelValue", "onUpdate:modelValue"])
                                ]);
                            }), 64))
                        ])),
                    _createVNode(MGButton, {
                        text: "Save",
                        onClick: _cache[0] || (_cache[0] = ($event) => (showConfirm.value = true)),
                        disabled: loading.value || saving.value,
                        small: true,
                        class: "save-btn"
                    }, null, 8, ["disabled"]),
                    (saving.value)
                        ? (_openBlock(), _createElementBlock("span", _hoisted_6, "Saving…"))
                        : _createCommentVNode("", true)
                ]),
                _createVNode(MGDialog, {
                    modelValue: showConfirm.value,
                    "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event) => ((showConfirm).value = $event)),
                    title: "Save System Status",
                    "max-width": "400px",
                    persistent: true
                }, {
                    content: _withCtx(() => _cache[6] || (_cache[6] = [
                        _createElementVNode("p", null, "Are you sure you want to save these system status changes?", -1)
                    ])),
                    actions: _withCtx(() => [
                        _createVNode(MGButton, {
                            text: "Save",
                            onClick: confirmSave,
                            stacked: true,
                            outline: ""
                        }),
                        _createVNode(MGButton, {
                            text: "Cancel",
                            onClick: _cache[1] || (_cache[1] = ($event) => (showConfirm.value = false)),
                            stacked: true
                        })
                    ]),
                    _: 1
                }, 8, ["modelValue"]),
                _createVNode(SuccessToast, {
                    count: savedCount.value,
                    "onUpdate:count": _cache[3] || (_cache[3] = ($event) => ((savedCount).value = $event)),
                    message: "System status saved"
                }, null, 8, ["count"])
            ]));
        };
    }
});
